import { FileField, FileInput, required } from "react-admin";
import AddIcon from "@mui/icons-material/Add";
import { Box, Typography } from "@mui/material";
import { validateFileType } from "utils/validations";
import { ALLOWED_FILE_EXTENSIONS } from "utils/constants";

const buildFormatsHint = extensions => `Позволени формати: ${extensions.join(", ")}.`;

// Shared file-upload field: renders the RA FileInput plus the allowed-formats hint and wires the
// validation. `extensions` is a prop so the same field can accept a different set per usage.
const AttachmentInput = ({
  source,
  label,
  isRequired = false,
  extensions = ALLOWED_FILE_EXTENSIONS,
  hint,
  placeholder = "Добавете файл за качване или кликнете, за да го изберете.",
}) => {
  return (
    <>
      <FileInput
        source={source}
        label={label}
        placeholder={
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
            <AddIcon />
            {placeholder}
          </Box>
        }
        validate={
          isRequired
            ? [required(), validateFileType({ isRequired: true, extensions })]
            : [validateFileType({ extensions })]
        }
      >
        <FileField
          source="src"
          title="title"
        />
      </FileInput>
      <Typography
        color="error"
        mb={3}
      >
        {hint ?? buildFormatsHint(extensions)}
      </Typography>
    </>
  );
};

export default AttachmentInput;
